//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global axios */

import Cookies from 'js-cookie';

export default {
  props: ['formId'],

  data() {
    return {
      isOpen: false,
      step: 1,
      name: '',
      city: '',
      phone: '',
      email: '',
      marketing: false,
      errors: {},
    };
  },

  computed: {
    ready() {
      return this.name && this.city && this.phone && this.email;
    },
  },

  mounted() {
    const closed = Cookies.get('super-oferta-closed');
    const superOfertaBtn = document.getElementById('super-oferta');

    superOfertaBtn.addEventListener('click', () => {
      this.isOpen ? this.close() : this.open();
    });

    if (closed) {
      return;
    }

    setTimeout(() => {
      this.open();
    }, 10 * 1000);
  },

  methods: {
    close() {
      this.reset();

      Cookies.set('super-oferta-closed', true, { expires: 7 });

      this.isOpen = false;

      document.body.classList.remove('overflow-hidden');
    },

    open() {
      this.isOpen = true;

      document.body.classList.add('overflow-hidden');
    },

    reset() {
      this.name = '';
      this.city = '';
      this.phone = '';
      this.email = '';
      this.step = 1;
      this.marketing = false;
      this.errors = {};
    },

    send() {
      if (!this.ready) {
        return;
      }

      axios.post('/wp-json/send-contact-form/v1/contact', {
        name: this.name,
        city: this.city,
        email: this.email,
        phone: this.phone,
        marketing: this.marketing,
      }).then(this.onSuccess).catch(this.onFail);
    },

    onSuccess({ data }) {
      this.step = 3;

      setTimeout(this.close, 3000);
    },

    onFail({ response: { data: { data: { errors } } } }) {
      this.errors = errors;
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/components/SuperOferta.vue